
<div class="dynamic-field-menu">
  <slot name="heading"></slot>
  <p v-if="max">{{currentValue.length}}/10 selected</p>
  <input v-if="!unsearchable" v-model="q" type="text" placeholder="Search">
  <div v-if="showDynamicMessage">{{dynamicMessage}}</div>

  <template v-if="!disabledMessage">
    <scroll-area class="dynamic-box">
      <template v-for="(handler, ind) in getAllHandlers">
        <component
            v-for="component in handler.COMPONENTS"
            :key="ind"
            :is="component"
            :handler="handler"
            :q="q"
            :parent="parent"
            :restrict-results-to-parent-context="restrictResultsToParentContext"
            @select="select"
            :from-model-view="fromModelView"
        ></component>
      </template>
    </scroll-area>
  </template>
  <template v-else>
    <div class="alert warning border justify-content-center">
      <icon glyph="exclamation-circle"/>&nbsp;<strong>{{ disabledMessage }}</strong>
    </div>
  </template>

  <div v-if="modeIs('checkbox')" class="cta">
    <button @click="cancel" class="btn block red outline">Cancel</button>
    <button @click="confirm" class="btn block green">Done</button>
  </div>
</div>
